import React, {useState} from "react";
import {Button, Col, Row, Tabs, message, Modal} from "antd";
import moment from "moment";
import DetailTable from "../../components/detailtable/DetailTable";
import './SignalAssetEventDetails.less';
import {CopyOutlined} from "@ant-design/icons";

const TabPane = Tabs.TabPane;

const SignalAssetEventDetails = ({assetEvents = []}) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [currentError, setCurrentError] = useState('');

    // Функция для показа полного текста ошибки
    const showFullError = (errorText) => {
        setCurrentError(errorText);
        setModalVisible(true);
    };

    // Функция для копирования ошибки в буфер обмена
    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(currentError);
            message.success('Текст ошибки скопирован');
        } catch (err) {
            message.error('Не удалось скопировать текст');
        }
    };

    // Функция для определения класса статуса
    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'completed':
            case 'success':
                return 'status-success';
            case 'error':
            case 'failed':
                return 'status-error';
            case 'processing':
            case 'in_progress':
                return 'status-processing';
            default:
                return 'status-default';
        }
    };

    return (
        <>
            <div className='ip-signall-asset-events-table'>
                <DetailTable>
                    <thead>
                    <tr>
                        <th className="column-id text-center">ID</th>
                        <th className="column-status text-center">Статус</th>
                        <th className="column-created text-center">Создан</th>
                        <th className="column-processing text-center">Обрабатывается</th>
                        <th className="column-done text-center">Завершен</th>
                        <th className="column-account text-left">Счет</th>
                        <th className="column-error-time text-center">Ошибка (время)</th>
                        <th className="column-error-message text-left">Ошибка (текст)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {assetEvents.map(({id, createdAt, processingAt, errorAt, doneAt, status, error, asset = {}}) => {
                        const {name: accountName} = asset;
                        return (
                            <tr key={id}>
                                <td className="column-id text-center"><span className="id-cell">#{id}</span></td>
                                <td>{status}</td>
                                <td>{createdAt ? moment(createdAt).format('DD.MM.YYYY HH:mm:ss') : null}</td>
                                <td className="column-processing text-center">
                                    <span className={`timestamp processing ${!processingAt ? 'empty' : ''}`}>
                                        {processingAt ? moment(processingAt).format('DD.MM.YYYY HH:mm') : '—'}
                                    </span>
                                </td>
                                <td className="column-done text-center">
                                    <span className={`timestamp completed ${!doneAt ? 'empty' : ''}`}>
                                        {doneAt ? moment(doneAt).format('DD.MM.YYYY HH:mm') : '—'}
                                    </span>
                                </td>
                                <td className="column-account text-left">
                                    <span className={`account-name ${!accountName ? 'empty' : ''}`}>
                                        {accountName || 'Не указан'}
                                    </span>
                                </td>
                                <td className="column-error-time text-center">
                                    <span className={`timestamp error ${!errorAt ? 'empty' : ''}`}>
                                        {errorAt ? moment(errorAt).format('DD.MM.YYYY HH:mm') : '—'}
                                    </span>
                                </td>
                                <td className="column-error-message text-left">
                                    <span
                                        className={`error-text ${!error ? 'empty' : ''}`}
                                        onClick={() => error && showFullError(error)}
                                        title={error ? "Нажмите для просмотра полного текста" : ""}
                                    >
                                        {error || '—'}
                                    </span>
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </DetailTable>
            </div>
            <Modal
                className="error-modal"
                title={
                    <div className="error-header">
                        <span className="error-title">Полный текст ошибки</span>
                        <Button
                            type="link"
                            icon={<CopyOutlined/>}
                            onClick={copyToClipboard}
                            className="copy-button"
                        >
                            Копировать
                        </Button>
                    </div>
                }
                open={modalVisible}
                onCancel={() => setModalVisible(false)}
                footer={[
                    <Button key="close" onClick={() => setModalVisible(false)}>
                        Закрыть
                    </Button>
                ]}
                width={600}
            >
                <div className="error-content">
                    {currentError}
                </div>
            </Modal>
        </>
    );
};

export default SignalAssetEventDetails;
